// extracted by mini-css-extract-plugin
export var createdDate = "_lv-1";
export var divider = "_lv-2";
export var headerDivider = "_lv-3";
export var messagesCard = "_lv-0";
export var messagesContainer = "_lv-6";
export var messagesContainerWrapper = "_lv-4";
export var showLeftPanelButton = "_lv-8";
export var topButtons = "_lv-7";
export var withPadding = "_lv-5";